export class DatePicked {
    start: Date;
    end: Date;

    constructor(s: Date, e: Date) {
        this.start = s;
        this.end = e;
    }
}
